"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _parameters = _interopRequireDefault(require("./parameters"));
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const isObject = v => typeof v === 'object' && Object.keys(v).length;
const isString = v => typeof v === 'string' && v.length;
var _default = (search, navigate) => {
  const params = new _parameters.default(search);
  const redirect = prefix => {
    const query = params.redirectStr();
    const path = prefix ? `${prefix}${query}` : query;
    return navigate(path);
  };
  return {
    params,
    redirect,
    getFrom(key) {
      if (isObject(key)) return params.populate(key);
      if (isString(key)) return params.get(key);
      return null;
    },
    getAll() {
      return (0, _utils.forEachParam)(params);
    },
    pushTo(values) {
      params.merge(values);
      redirect();
      window.scrollTo(0, 0);
    },
    clearByName(next) {
      return e => {
        e.stopPropagation();
        params.delete(e.currentTarget.name);
        redirect();
        next();
      };
    },
    handleSearch(next, redirectPath) {
      return _ref => {
        let {
          key,
          target
        } = _ref;
        if (key !== 'Enter') return;
        if (!isString(target.value)) {
          params.delete('search');
        } else {
          params.set('search', target.value);
        }
        params.delete('page');
        redirect(redirectPath);
        next();
      };
    }
  };
};
exports.default = _default;